import React from 'react';
import PropTypes from 'prop-types';
import HistoryItem from "./HistoryItem";
import {Button} from 'reactstrap';
import {FormattedMessage} from "react-intl";

class History extends React.Component {
    static propTypes = {
        length: PropTypes.number.isRequired,
        list: PropTypes.arrayOf(PropTypes.shape({
            date: PropTypes.object.isRequired,
            revenue: PropTypes.number,
            type: PropTypes.string.isRequired,
            phone: PropTypes.string.isRequired,
            dateEnd: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        })).isRequired,
        onLoadMoreContacts: PropTypes.func.isRequired,
    };

    render() {
        const {list, onLoadMoreContacts, length} = this.props;

        if (!list || list.length === 0) {
            return <div className="error-container">
                <h2>
                    <FormattedMessage id="stats.no_results" defaultMessage="No results have been found" />
                </h2>
            </div>
        }

        return (
            <div className="stats__list">
                <table>
                    {list.map((item, idx) => (
                        <HistoryItem item={item} key={idx} />
                    ))}
                </table>
                {list.length < length &&
                <Button className="btn-clickable mt-3 mb-4" onClick={onLoadMoreContacts}>
                    <FormattedMessage id="stats.load_more" defaultMessage="Load more"/>
                </Button>
                }
            </div>
        )
    }
}

export default History;


// WEBPACK FOOTER //
// ./src/containers/Stats/History.jsx